/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2021-2025 (original work) Open Assessment Technologies SA
 */

import moment from 'moment';

const setMomentLocale = async (localeCode) => {
    try {
        switch (localeCode) {
            case 'af':
                await import('moment/locale/af');
                break;
            case 'ar-dz':
                await import('moment/locale/ar-dz');
                break;
            case 'ar-kw':
                await import('moment/locale/ar-kw');
                break;
            case 'ar-ly':
                await import('moment/locale/ar-ly');
                break;
            case 'ar-ma':
                await import('moment/locale/ar-ma');
                break;
            case 'ar-sa':
                await import('moment/locale/ar-sa');
                break;
            case 'ar-tn':
                await import('moment/locale/ar-tn');
                break;
            case 'ar':
                await import('moment/locale/ar');
                break;
            case 'az':
                await import('moment/locale/az');
                break;
            case 'be':
                await import('moment/locale/be');
                break;
            case 'bg':
                await import('moment/locale/bg');
                break;
            case 'bm':
                await import('moment/locale/bm');
                break;
            case 'bn':
                await import('moment/locale/bn');
                break;
            case 'bo':
                await import('moment/locale/bo');
                break;
            case 'br':
                await import('moment/locale/br');
                break;
            case 'bs':
                await import('moment/locale/bs');
                break;
            case 'ca':
                await import('moment/locale/ca');
                break;
            case 'cs':
                await import('moment/locale/cs');
                break;
            case 'cv':
                await import('moment/locale/cv');
                break;
            case 'cy':
                await import('moment/locale/cy');
                break;
            case 'da':
                await import('moment/locale/da');
                break;
            case 'de-at':
                await import('moment/locale/de-at');
                break;
            case 'de-ch':
                await import('moment/locale/de-ch');
                break;
            case 'de':
            case 'de-de':
                await import('moment/locale/de');
                break;
            case 'dv':
                await import('moment/locale/dv');
                break;
            case 'el':
                await import('moment/locale/el');
                break;
            case 'en-au':
                await import('moment/locale/en-au');
                break;
            case 'en-ca':
            case 'en-us':
                await import('moment/locale/en-ca');
                break;
            case 'en-gb':
                await import('moment/locale/en-gb');
                break;
            case 'en-ie':
                await import('moment/locale/en-ie');
                break;
            case 'en-il':
                await import('moment/locale/en-il');
                break;
            case 'en-nz':
                await import('moment/locale/en-nz');
                break;
            case 'en-sg':
                await import('moment/locale/en-sg');
                break;
            case 'eo':
                await import('moment/locale/eo');
                break;
            case 'es-do':
                await import('moment/locale/es-do');
                break;
            case 'es-mx':
                await import('moment/locale/es-mx');
                break;
            case 'es-us':
                await import('moment/locale/es-us');
                break;
            case 'es':
            case 'es-es':
                await import('moment/locale/es');
                break;
            case 'et':
                await import('moment/locale/et');
                break;
            case 'eu':
                await import('moment/locale/eu');
                break;
            case 'fa':
                await import('moment/locale/fa');
                break;
            case 'fi':
                await import('moment/locale/fi');
                break;
            case 'fil':
                await import('moment/locale/fil');
                break;
            case 'fo':
                await import('moment/locale/fo');
                break;
            case 'fr-ca':
                await import('moment/locale/fr-ca');
                break;
            case 'fr-ch':
                await import('moment/locale/fr-ch');
                break;
            case 'fr':
            case 'fr-be':
            case 'fr-fr':
                await import('moment/locale/fr');
                break;
            case 'fy':
                await import('moment/locale/fy');
                break;
            case 'ga':
                await import('moment/locale/ga');
                break;
            case 'gd':
                await import('moment/locale/gd');
                break;
            case 'gl':
                await import('moment/locale/gl');
                break;
            case 'gom-latn':
                await import('moment/locale/gom-latn');
                break;
            case 'gu':
                await import('moment/locale/gu');
                break;
            case 'he':
            case 'he-il':
                await import('moment/locale/he');
                break;
            case 'hi':
                await import('moment/locale/hi');
                break;
            case 'hr':
                await import('moment/locale/hr');
                break;
            case 'hu':
                await import('moment/locale/hu');
                break;
            case 'hy-am':
                await import('moment/locale/hy-am');
                break;
            case 'id':
                await import('moment/locale/id');
                break;
            case 'is':
                await import('moment/locale/is');
                break;
            case 'it':
            case 'it-it':
                await import('moment/locale/it');
                break;
            case 'ja':
            case 'ja-jp':
                await import('moment/locale/ja');
                break;
            case 'jv':
                await import('moment/locale/jv');
                break;
            case 'ka':
                await import('moment/locale/ka');
                break;
            case 'kk':
                await import('moment/locale/kk');
                break;
            case 'km':
                await import('moment/locale/km');
                break;
            case 'kn':
                await import('moment/locale/kn');
                break;
            case 'ko':
                await import('moment/locale/ko');
                break;
            case 'ku':
                await import('moment/locale/ku');
                break;
            case 'ky':
                await import('moment/locale/ky');
                break;
            case 'lb':
                await import('moment/locale/lb');
                break;
            case 'lo':
                await import('moment/locale/lo');
                break;
            case 'lt':
            case 'lt-lt':
                await import('moment/locale/lt');
                break;
            case 'lv':
                await import('moment/locale/lv');
                break;
            case 'me':
                await import('moment/locale/me');
                break;
            case 'mi':
                await import('moment/locale/mi');
                break;
            case 'mk':
                await import('moment/locale/mk');
                break;
            case 'ml':
                await import('moment/locale/ml');
                break;
            case 'mn':
                await import('moment/locale/mn');
                break;
            case 'mr':
                await import('moment/locale/mr');
                break;
            case 'ms-my':
                await import('moment/locale/ms-my');
                break;
            case 'ms':
                await import('moment/locale/ms');
                break;
            case 'mt':
                await import('moment/locale/mt');
                break;
            case 'my':
                await import('moment/locale/my');
                break;
            case 'nb':
            case 'nb-no':
                await import('moment/locale/nb');
                break;
            case 'ne':
                await import('moment/locale/ne');
                break;
            case 'nl-be':
                await import('moment/locale/nl-be');
                break;
            case 'nl':
            case 'nl-nl':
                await import('moment/locale/nl');
                break;
            case 'nn':
            case 'nn-no':
                await import('moment/locale/nn');
                break;
            case 'oc-lnc':
                await import('moment/locale/oc-lnc');
                break;
            case 'pa-in':
                await import('moment/locale/pa-in');
                break;
            case 'pl':
                await import('moment/locale/pl');
                break;
            case 'pt-br':
                await import('moment/locale/pt-br');
                break;
            case 'pt':
            case 'pt-pt':
                await import('moment/locale/pt');
                break;
            case 'ro':
            case 'ro-ro':
                await import('moment/locale/ro');
                break;
            case 'ru':
            case 'ru-ru':
                await import('moment/locale/ru');
                break;
            case 'sd':
                await import('moment/locale/sd');
                break;
            case 'se':
                await import('moment/locale/se');
                break;
            case 'si':
                await import('moment/locale/si');
                break;
            case 'sk':
                await import('moment/locale/sk');
                break;
            case 'sl':
                await import('moment/locale/sl');
                break;
            case 'sq':
                await import('moment/locale/sq');
                break;
            case 'sr-cyrl':
                await import('moment/locale/sr-cyrl');
                break;
            case 'sr':
                await import('moment/locale/sr');
                break;
            case 'ss':
                await import('moment/locale/ss');
                break;
            case 'sv':
                await import('moment/locale/sv');
                break;
            case 'sw':
                await import('moment/locale/sw');
                break;
            case 'ta':
                await import('moment/locale/ta');
                break;
            case 'te':
                await import('moment/locale/te');
                break;
            case 'tet':
                await import('moment/locale/tet');
                break;
            case 'tg':
                await import('moment/locale/tg');
                break;
            case 'th':
                await import('moment/locale/th');
                break;
            case 'tk':
                await import('moment/locale/tk');
                break;
            case 'tl-ph':
                await import('moment/locale/tl-ph');
                break;
            case 'tlh':
                await import('moment/locale/tlh');
                break;
            case 'tr':
                await import('moment/locale/tr');
                break;
            case 'tzl':
                await import('moment/locale/tzl');
                break;
            case 'tzm':
                await import('moment/locale/tzm');
                break;
            case 'tzm-latn':
                await import('moment/locale/tzm-latn');
                break;
            case 'ug-cn':
                await import('moment/locale/ug-cn');
                break;
            case 'uk':
                await import('moment/locale/uk');
                break;
            case 'ur':
                await import('moment/locale/ur');
                break;
            case 'uz':
                await import('moment/locale/uz');
                break;
            case 'uz-latn':
                await import('moment/locale/uz-latn');
                break;
            case 'vi':
                await import('moment/locale/vi');
                break;
            case 'x-pseudo':
                await import('moment/locale/x-pseudo');
                break;
            case 'yo':
                await import('moment/locale/yo');
                break;
            case 'zh-cn':
                await import('moment/locale/zh-cn');
                break;
            case 'zh-hk':
                await import('moment/locale/zh-hk');
                break;
            case 'zh-mo':
                await import('moment/locale/zh-mo');
                break;
            case 'zh-tw':
                await import('moment/locale/zh-tw');
                break;
            case 'val-es':
                await import('moment/locale/ca');
                break;
            default:
                localeCode = 'en';
                await import('moment/locale/en-gb');
                break;
        }
        moment.locale(localeCode);
    } catch (error) {
        moment.locale('en');
    }
};

export { setMomentLocale };
